import React from 'react';
import styled from 'styled-components';
import { Loader } from '../../../components/shared';
import useGetOrganizationLogo from '../../../hooks/useGetOrganizationLogo';

export const HeaderCompanyLogo = () => {
  const { logo, isLoadingLogo } = useGetOrganizationLogo();

  return (
    <S.CompanyLogoContainer>
      {isLoadingLogo ? <Loader /> : <S.CompanyLogo src={logo} data-cy='logo' />}
    </S.CompanyLogoContainer>
  );
};

const LOGO_CONTAINER_HEIGHT = 50;

const S = {
  CompanyLogoContainer: styled.div`
    height: ${LOGO_CONTAINER_HEIGHT}px;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  CompanyLogo: styled.img`
    max-width: 100%;
    height: ${LOGO_CONTAINER_HEIGHT}px;
  `,
};
